import {
  CREATEMESHNETWORK,
  CREATEMESHNETWORK_SUCCESS,
  UPDATEMESHNETWORK,
  UPDATEMESHNETWORK_SUCCESS,
  FETCHMESHNETWORK,
  FETCHMESHNETWORK_SUCCESS,
  FETCHMESHNETWORKS,
  FETCHMESHNETWORKS_SUCCESS,
  DELETEMESHNETWORK,
  DELETEMESHNETWORK_SUCCESS,
  CREATEMESHAPPLICATION,
  CREATEMESHAPPLICATION_SUCCESS,
  UPDATEMESHAPPLICATION,
  UPDATEMESHAPPLICATION_SUCCESS,
  FETCHMESHAPPLICATIONS,
  FETCHMESHAPPLICATIONS_SUCCESS,
  DELETEMESHAPPLICATION,
  DELETEMESHAPPLICATION_SUCCESS,
  MESHDISCOVERUNPROVISIONED,
  MESHDISCOVERUNPROVISIONED_SUCCESS,
  MESHPROVISION,
  MESHPROVISION_SUCCESS,
  MESHGET,
  MESHGET_SUCCESS,
  MESHSET,
  MESHSET_SUCCESS,
  DESCRIBEJOBEXECUTION,
  DESCRIBEJOBEXECUTION_SUCCESS
} from "constants/ActionTypes";

export const fetchMeshNetworks = (applicationId) => {
  console.log('fetchMeshNetworks', applicationId);
  return {
    type: FETCHMESHNETWORKS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchMeshNetworksSuccess = (meshNetworks, applicationId) => {
  console.log('fetchMeshNetworksSuccess', meshNetworks, applicationId);

  return {
    type: FETCHMESHNETWORKS_SUCCESS,
    applicationId: applicationId,
    payload: meshNetworks
  };
};

export const createMeshNetwork = (creatingMeshNetwork) => {
  console.log('creatingMeshNetwork', creatingMeshNetwork)
  return {
    type: CREATEMESHNETWORK,
    payload: creatingMeshNetwork
  };
};

export const createMeshNetworkSuccess = (createdMeshNetwork) => {
  return {
    type: CREATEMESHNETWORK_SUCCESS,
    payload: createdMeshNetwork
  };
};

export const updateMeshNetwork = (updatingMeshNetwork) => {
  console.log('updatingMeshNetwork', updatingMeshNetwork)
  return {
    type: UPDATEMESHNETWORK,
    payload: updatingMeshNetwork
  };
};

export const updateMeshNetworkSuccess = (updatedMeshNetwork) => {
  console.log('updatedMeshNetwork', updatedMeshNetwork)

  return {
    type: UPDATEMESHNETWORK_SUCCESS,
    payload: updatedMeshNetwork
  };
};

export const deleteMeshNetwork = (deletingMeshNetwork) => {

  return {
    type: DELETEMESHNETWORK,
    payload: deletingMeshNetwork
  };
};

export const deleteMeshNetworkSuccess = (deletedMeshNetwork) => {

  return {
    type: DELETEMESHNETWORK_SUCCESS,
    payload: deletedMeshNetwork
  };
};

export const createMeshApplication = (creatingMeshApplication) => {
  console.log('creatingMeshApplication', creatingMeshApplication)
  return {
    type: CREATEMESHAPPLICATION,
    payload: creatingMeshApplication
  };
};

export const createMeshApplicationSuccess = (createdMeshApplication) => {
  return {
    type: CREATEMESHAPPLICATION_SUCCESS,
    payload: createdMeshApplication
  };
};

export const updateMeshApplication = (updatingMeshApplication) => {
  console.log('updatingMeshApplication', updatingMeshApplication)
  return {
    type: UPDATEMESHAPPLICATION,
    payload: updatingMeshApplication
  };
};

export const updateMeshApplicationSuccess = (updatedMeshApplication) => {
  console.log('updatedMeshApplication', updatedMeshApplication)

  return {
    type: UPDATEMESHAPPLICATION_SUCCESS,
    payload: updatedMeshApplication
  };
};

export const deleteMeshApplication = (deletingMeshApplication) => {

  return {
    type: DELETEMESHAPPLICATION,
    payload: deletingMeshApplication
  };
};

export const deleteMeshApplicationSuccess = (deletedMeshApplication) => {

  return {
    type: DELETEMESHAPPLICATION_SUCCESS,
    payload: deletedMeshApplication
  };
};

export const meshDiscoverUnprovisioned = (provisionerId) => {

  return {
    type: MESHDISCOVERUNPROVISIONED,
    payload: {
      provisionerId
    }
  };
};

export const meshDiscoverUnprovisionedSuccess = (job) => {
  console.log('MESHDISCOVERUNPROVISIONED_SUCCESS', job);

  return {
    type: MESHDISCOVERUNPROVISIONED_SUCCESS,
    payload: job
  };
};

export const meshProvision = (provisionerId, deviceId) => {

  return {
    type: MESHPROVISION,
    payload: {
      provisionerId,
      deviceId
    }
  };
};

export const meshProvisionSuccess = (job) => {

  return {
    type: MESHPROVISION_SUCCESS,
    payload: job
  };
};

export const meshGet = (provisionerId, unicastAddr, model, deviceId) => {

  return {
    type: MESHGET,
    payload: {
      provisionerId,
      unicastAddr,
      model,
      deviceId
    }
  };
};

export const meshGetSuccess = (job) => {

  return {
    type: MESHGET_SUCCESS,
    payload: job
  };
};

export const meshSet = (provisionerId, unicastAddr, model, state) => {

  return {
    type: MESHSET,
    payload: {
      provisionerId,
      unicastAddr,
      model,
      state
    }
  };
};

export const meshSetSuccess = (job) => {

  return {
    type: MESHSET_SUCCESS,
    payload: job
  };
};

export const describeJobExecution = (jobId, deviceId) => {

  return {
    type: DESCRIBEJOBEXECUTION,
    payload: {
      jobId,
      deviceId
    }
  };
};

export const describeJobExecutionSuccess = (jobId, status) => {

  return {
    type: DESCRIBEJOBEXECUTION_SUCCESS,
    jobId: jobId,
    payload: status
  };
};
